// src/components/ThankYou.tsx
import { Box, Button, Typography } from '@mui/material';
import React from 'react';

const ThankYou = () => {

    // useEffect(() => {
    //     const hasRefreshed = sessionStorage.getItem('thankyou_refreshed');
    //     if (!hasRefreshed) {
    //       sessionStorage.setItem('thankyou_refreshed', 'true');
    //       window.location.reload();
    //     }
    //   }, []);
  return (
    <Box sx={{
            width: 689,
            height: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: 3,
            backgroundColor: "#fff",
            margin: "auto",
            '@media (max-width: 689px)': {
                width: '100%'
            }
         }}
    >
        <img
            src={`https://members.performancegolf.com/wp-content/uploads/2025/03/icon-gift-sent.png`}
            alt="Gift Icon"
            style={{ width: 170, height: 70, marginBottom: 10 }}
        />

        <Typography
            fontSize={25}
            textAlign="center"
            lineHeight="130%"
        >
            Your Gift Is On Its Way… 
        </Typography>

        <Typography
            fontSize={25}
            fontWeight="normal"
            textAlign="center"
            lineHeight="130%"
            marginBottom="50px"
        >
            Now Give <span style={{ textDecoration: 'underline', textTransform: 'uppercase' }}>YOURSELF</span> Something Special!
        </Typography>

        <Box
            sx={{
                width: 689,
                height: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 3,
                backgroundColor: "#fff",
                margin: "auto",
                '@media (max-width: 800px)': {
                    width: '100%',
                    margin:0,
                    padding:0
                }
            }}
        >
            <Box
                sx={{
                    width: 689,
                    borderRadius: 2,
                    border: "4px solid #355ADD",
                    padding: "50px 30px 50px 30px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    '@media (max-width: 800px)': {
                        width: '107%',
                        padding: "50px 20px",
                    }
                }}
                >
                <Box
                    sx={{
                    width: "100%",
                    height: 42,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderBottom: "4px solid #355ADD",
                    backgroundColor: "#355ADD",
                    position: "absolute", // Positions it at the top
                    top: 0,
                    left: 0,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 20,
                            fontWeight: "bold",
                            color: "white",
                            lineHeight: "130%",
                            textTransform: "uppercase",
                            '@media (max-width: 400px)': {
                                fontSize: 18
                            }
                        }}
                    >
                    New Players Club Members Only:
                    </Typography>
                </Box>

                <Typography
                    sx={{
                        marginTop: "42px",
                        fontSize:35,
                        lineHeight:"120%",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginBottom: "20px",
                        "@media (max-width:900px)":{
                             fontSize: "30px"
                        },
                        "& .desktop-br": {
                            display: "inline",
                            "@media (max-width: 999px)": {
                                display: "none",
                            }
                        }
                    }}
                >
                    Save $1000 On <span style={{ fontStyle: "italic", textTransform: "uppercase" }}>ANY</span><span className="desktop-br"><br /></span> VIP Golf Experience
                </Typography>

                <picture>
                    <source
                        srcSet={`https://members.performancegolf.com/wp-content/uploads/2025/03/coaches_mobile.png`}
                        media="(max-width: 698px)"
                    />
                    <img
                        src={`https://members.performancegolf.com/wp-content/uploads/2025/03/coaches-gift.png`}
                        alt="Coaches"
                        style={{ width: "100%", maxWidth: 600, height: "auto", marginBottom: 20 }}
                    />
                </picture>

                <Typography
                    sx={{
                        fontSize:25,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >This immersive learning experience combines:</Typography>
                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >Cutting edge swing technology like <span style={{ textTransform: "uppercase" }}>GEARS</span>
                </Typography>

                <Typography
                    sx={{
                        width: "65%",
                        height: "1px",
                        backgroundColor: "#CECCCC",
                        marginBottom: "20px",
                        textAlign: "center",
                        "@media (max-width:600px)":{
                             width: "100%"
                        },
                    }}
                />
                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >Personalized feedback from a world class coach like:
                </Typography>

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >Golf Digest Top 5 Cameron McCormick
                </Typography>

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >Top 10 Martin Chuck</Typography>


                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >#1 Female Instructor In The World Erika Larkin</Typography>

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >Golf Digest Top 25 Andrew Rice</Typography>

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >#1 Coach In Oregon Jeff Ritter</Typography>


                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >And <span style={{ textTransform: "uppercase" }}>SO</span> many more!</Typography>

                <Typography
                    sx={{
                        width: "65%",
                        height: "1px",
                        backgroundColor: "#CECCCC",
                        marginBottom: "20px",
                        "@media (max-width:600px)":{
                             width: "100%"
                        },
                    }}
                />

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        textAlign: "center",
                        marginBottom: "20px",
                        "& .desktop-br": {
                            display: "inline",
                            "@media (max-width: 999px)": {
                                display: "none",
                            }
                        }
                    }}
                >That’s why Players who attend these experiences make more progress in 2 or 3 days than<span className="desktop-br"><br /></span> most golfers make in 2 or 3 years.</Typography>

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >(Plus the whole time you get the royal treatment!)</Typography>

                <Typography
                    sx={{
                        width: "65%",
                        height: "1px",
                        backgroundColor: "#CECCCC",
                        marginBottom: "20px",
                        "@media (max-width:600px)":{
                             width: "100%"
                        },
                    }}
                />

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"semibold",
                        textAlign: "center"
                    }}
                >To join us, click the link below to book a call and find the perfect camp for you.</Typography>

                <Typography
                    sx={{
                        fontSize:16,
                        lineHeight:"130%",
                        fontWeight:"bold",
                        marginBottom: "20px",
                        textAlign: "center"
                    }}
                >Remember: Use the code PLATINUM to save $1000!</Typography>
                <Button
                    sx={{
                        width: "236px",
                        height: "42px",
                        backgroundColor: "#355ADD",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "20px",
                        textTransform: "none",
                        "&:hover": {
                            opacity: 1,
                            backgroundColor: "#163190 !important",
                        }
                    }}
                    onClick={() => {
                        const email = window.pgUser.user_email;
                        const firstName = window.pgUser.first_name;
                        const lastName = window.pgUser.last_name;

                        const url = `https://surveys.performancegolfzone.com/s3/vip-golf-experience-event?email=${encodeURIComponent(email)}&first_name=${encodeURIComponent(firstName)}&last_name=${encodeURIComponent(lastName)}&utm_medium=member&utm_campaign=member_gift`;

                        window.location.href = url;  // Navigate to the URL
                    }}
                    >
                    Learn More & Schedule
                </Button>


            </Box>
        </Box>
    </Box>
  );
};

export default ThankYou;
